<div class="eco-page">
  <!-- Top Navigation -->
  <header class="eco-header flex align-items-center justify-content-between">
    <div class="flex align-items-center gap-3">
      <div class="eco-brand-badge">
        <img src="assets/ecodados-symbol.svg" alt="EcoDados Logo">
      </div>
      <h1 class="eco-title text-lg my-0">EcoDados <span class="font-normal text-600">| Indicadores</span></h1>
    </div>
    
    <div class="flex align-items-center gap-2">
      <nav class="hidden md:flex eco-nav">
        <a routerLink="/coletas" routerLinkActive="active" class="eco-nav-link">Minhas Coletas</a>
        <a routerLink="/indicadores" routerLinkActive="active" class="eco-nav-link">Painel Admin</a>
        <a routerLink="/analytics" routerLinkActive="active" class="eco-nav-link">Gráficos</a>
      </nav>
      
      <p-button icon="pi pi-sign-out" [text]="true" [rounded]="true" severity="secondary" (onClick)="logout()" pTooltip="Sair do sistema" styleClass="hidden md:inline-flex" />

      <!-- Botão Menu Mobile -->
      <p-button icon="pi pi-bars" [text]="true" [rounded]="true" severity="secondary" styleClass="md:hidden" (onClick)="showMobileMenu.set(true)" aria-label="Abrir menu de navegação" />
    </div>
  </header>

  <main class="eco-container flex flex-column gap-4">
    <!-- Barra de Ferramentas / Ações dos Indicadores -->
    <div class="flex flex-column sm:flex-row sm:align-items-center justify-content-between gap-3 pt-1">
      <div class="flex align-items-center gap-3">
        <h2 class="eco-title text-xl my-0">Indicadores</h2>
        @if (!loading()) {
          <p-tag [value]="indicators().length + (indicators().length === 1 ? ' total' : ' totais')" severity="secondary" [rounded]="true" />
        }
      </div>

      <div class="flex align-items-center gap-2 flex-wrap">
        <p-button 
          label="Importar (.xlsx)" 
          icon="pi pi-upload" 
          severity="secondary" 
          [outlined]="true"
          size="small" 
          [rounded]="true" 
          (onClick)="openImportModal()" />

        <p-button 
          label="Exportar (.xlsx)" 
          icon="pi pi-download" 
          severity="secondary" 
          [outlined]="true"
          size="small" 
          [rounded]="true" 
          [loading]="dataTransferService.exporting()" 
          (onClick)="exportXlsx()" />

        <p-button 
          label="Novo Indicador" 
          icon="pi pi-plus" 
          severity="primary" 
          size="small" 
          [rounded]="true" 
          routerLink="/indicadores/novo" />
      </div>
    </div>

    <!-- Abas de Navegação (Ativos / Arquivados / Por Responsável) -->
    <div class="eco-toolbar w-full sm:w-max">
      <button 
        (click)="activeTab.set('ativos')" 
        [class.active]="activeTab() === 'ativos'" 
        class="eco-tab-button flex align-items-center gap-2">
        <span><span class="hidden sm:inline">Indicadores </span>Ativos</span>
        <span class="px-2 py-1 border-round-3xl text-xs bg-teal-100 text-teal-800 font-bold">
          {{ activeIndicators().length }}
        </span>
      </button>

      <button 
        (click)="activeTab.set('arquivados')" 
        [class.active]="activeTab() === 'arquivados'" 
        class="eco-tab-button flex align-items-center gap-2">
        <span>Arquivados<span class="hidden sm:inline"> / Inativos</span></span>
        <span class="px-2 py-1 border-round-3xl text-xs bg-teal-50 text-600 font-bold">
          {{ archivedIndicators().length }}
        </span>
      </button>

      <button 
        (click)="activeTab.set('responsaveis')" 
        [class.active]="activeTab() === 'responsaveis'" 
        class="eco-tab-button flex align-items-center gap-2">
        <span>Por Responsável</span>
        <span class="px-2 py-1 border-round-3xl text-xs bg-teal-100 text-teal-800 font-bold">
          {{ responsaveisPessoas().length }}
        </span>
      </button>
    </div>

    <!-- Conteúdo das Abas -->
    @if (loading()) {
      <div class="flex flex-column align-items-center justify-content-center py-6 gap-3">
        <div class="w-3rem h-3rem border-circle border-3 border-teal-200 border-t-teal-700 eco-spin"></div>
        <p class="eco-meta">Carregando indicadores...</p>
      </div>
    } @else {

      <!-- ABA 1: INDICADORES ATIVOS -->
      @if (activeTab() === 'ativos') {
        <div class="grid">
          @for (item of activeIndicators(); track item.id) {
            <div class="col-12 md:col-6 lg:col-4">
              <article class="eco-card flex flex-column justify-content-between h-full">
                <div>
                  <div class="flex justify-content-between align-items-center mb-3">
                    <p-tag [value]="item.sigla" severity="info" [rounded]="true" />
                    <p-tag value="Ativo" severity="success" [rounded]="true" />
                  </div>

                  <h3 class="eco-card-title mb-2 mt-0">
                    {{ item.nome }}
                  </h3>
                  <p class="eco-meta flex align-items-center gap-2 mb-3 mt-0">
                    <span class="material-symbols-outlined text-sm text-teal-700">straighten</span>
                    Unidade: <span class="font-bold text-teal-800">{{ item.unidade_medida }}</span>
                  </p>
                </div>

                <div class="mt-2 flex align-items-center justify-content-between border-t-1 border-teal-100 pt-3">
                  <div class="flex flex-column gap-1 min-w-0 flex-1 mr-2">
                    <span class="eco-label">Responsáveis</span>
                    <div class="flex align-items-center gap-1 min-w-0">
                      <span class="material-symbols-outlined text-sm text-teal-700 flex-shrink-0">person</span>
                      <span class="eco-meta font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 14rem;">
                        @if (item.responsaveis_nomes && item.responsaveis_nomes.length > 0) {
                          {{ item.responsaveis_nomes.slice(0, 2).join(', ') }}{{ item.responsaveis_nomes.length > 2 ? ' + ' + (item.responsaveis_nomes.length - 2) : '' }}
                        } @else {
                          <span class="font-normal font-italic" style="color: var(--eco-text-muted);">Sem responsável</span>
                        }
                      </span>
                    </div>
                  </div>
                  
                  <div class="flex align-items-center gap-1 flex-shrink-0">
                    <p-button icon="pi pi-calendar-plus" styleClass="eco-card-action eco-card-action-create" severity="secondary" (onClick)="openCreateCollectionModal(item)" pTooltip="Criar coleta" aria-label="Criar coleta para este indicador" />
                    <p-button icon="pi pi-pencil" styleClass="eco-card-action eco-card-action-edit" severity="primary" (onClick)="editIndicator(item.id)" pTooltip="Editar" aria-label="Editar indicador" />
                    <p-button icon="pi pi-inbox" styleClass="eco-card-action eco-card-action-archive" severity="secondary" (onClick)="openArchiveConfirmation(item)" pTooltip="Arquivar" aria-label="Arquivar indicador" />
                  </div>
                </div>
              </article>
            </div>
          } @empty {
            <div class="col-12 py-6 text-center flex flex-column align-items-center gap-3">
              <span class="material-symbols-outlined text-5xl text-400">inventory_2</span>
              <div>
                <p class="font-bold text-lg my-0">Nenhum indicador ativo cadastrado</p>
                <p class="eco-meta my-0 mt-1">Comece adicionando uma métrica institucional ou importando uma planilha.</p>
              </div>
            </div>
          }
        </div>
      } 

      <!-- ABA 2: ARQUIVADOS / INATIVOS (Permite Exclusão Definitiva) -->
      @else if (activeTab() === 'arquivados') {
        <div class="grid">
          @for (item of archivedIndicators(); track item.id) {
            <div class="col-12 md:col-6 lg:col-4">
              <article class="eco-card-low flex flex-column justify-content-between h-full opacity-90 hover:opacity-100">
                <div>
                  <div class="flex justify-content-between align-items-center mb-3">
                    <p-tag [value]="item.sigla" severity="secondary" [rounded]="true" />
                    <p-tag value="Arquivado" severity="danger" [rounded]="true" />
                  </div>

                  <h3 class="eco-card-title text-600 mb-2 mt-0 line-through">
                    {{ item.nome }}
                  </h3>
                  <p class="eco-meta flex align-items-center gap-2 mb-3 mt-0">
                    <span class="material-symbols-outlined text-sm">straighten</span>
                    Unidade: <span class="font-bold">{{ item.unidade_medida }}</span>
                  </p>
                </div>

                <div class="mt-2 flex align-items-center justify-content-between border-t-1 border-teal-200 pt-3">
                  <div class="flex flex-column gap-1 min-w-0 flex-1 mr-2">
                    <span class="eco-label">Responsáveis</span>
                    <div class="flex align-items-center gap-1 min-w-0">
                      <span class="material-symbols-outlined text-sm opacity-50 flex-shrink-0">person</span>
                      <span class="eco-meta font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 14rem;">
                        @if (item.responsaveis_nomes && item.responsaveis_nomes.length > 0) {
                          {{ item.responsaveis_nomes.slice(0, 2).join(', ') }}{{ item.responsaveis_nomes.length > 2 ? ' + ' + (item.responsaveis_nomes.length - 2) : '' }}
                        } @else {
                          <span class="font-italic opacity-50">Sem responsável</span>
                        }
                      </span>
                    </div>
                  </div>
                  
                  <div class="flex align-items-center gap-1 flex-shrink-0">
                    <p-button icon="pi pi-undo" styleClass="eco-card-action eco-card-action-edit" severity="success" (onClick)="unarchiveIndicator(item)" pTooltip="Reativar indicador" aria-label="Reativar indicador" />
                    <p-button icon="pi pi-trash" styleClass="eco-card-action eco-card-action-danger" severity="danger" (onClick)="openDeleteConfirmation(item)" pTooltip="Excluir definitivamente" aria-label="Excluir indicador definitivamente" />
                  </div>
                </div>
              </article>
            </div>
          } @empty {
            <div class="col-12 py-6 text-center flex flex-column align-items-center gap-3">
              <span class="material-symbols-outlined text-5xl text-400">archive</span>
              <div>
                <p class="font-bold text-lg my-0">Nenhum indicador arquivado</p>
                <p class="eco-meta my-0 mt-1">Indicadores inativados aparecerão nesta aba.</p>
              </div>
            </div>
          }
        </div>
      }

      <!-- ABA 3: POR RESPONSÁVEL (Nova Visão Agrupada) -->
      @else if (activeTab() === 'responsaveis') {
        <div class="flex flex-column gap-3">
          <!-- Barra de Busca e Ação de Novo Responsável -->
          <div class="flex flex-column sm:flex-row sm:align-items-center justify-content-between gap-3 bg-white p-3 border-round-2xl border-1 border-teal-100 shadow-sm">
            <div class="relative flex-1 max-w-25rem">
              <span class="material-symbols-outlined absolute left-0 top-50 transform -translate-y-50 ml-3 text-500">search</span>
              <input 
                type="text" 
                [ngModel]="searchResponsavelQuery()" 
                (ngModelChange)="searchResponsavelQuery.set($event)"
                placeholder="Buscar responsável por e-mail..." 
                class="eco-input pl-6 w-full" style="padding-left: 2.75rem !important;">
            </div>

            <p-button 
              label="Novo Responsável" 
              icon="pi pi-user-plus" 
              severity="primary" 
              size="small" 
              [rounded]="true" 
              (onClick)="openNewResponsavelModal()" />
          </div>

          <!-- Grid de Cards de Responsáveis -->
          <div class="grid">
            @for (pessoa of filteredResponsaveisPessoas(); track pessoa.email) {
              <div class="col-12 md:col-6 lg:col-4">
                <article class="eco-card flex flex-column justify-content-between h-full">
                  <div>
                    <div class="flex justify-content-between align-items-start mb-3 gap-2">
                      <div class="flex align-items-center gap-2 min-w-0 flex-1">
                        <span class="material-symbols-outlined text-teal-700 flex-shrink-0">person</span>
                        <span class="font-bold text-sm text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis" [pTooltip]="pessoa.email">
                          {{ pessoa.email }}
                        </span>
                      </div>
                      <p-tag [value]="(pessoa.indicadores.length || pessoa.totalIndicadores || 0) + ((pessoa.indicadores.length || pessoa.totalIndicadores || 0) === 1 ? ' indicador' : ' indicadores')" severity="info" [rounded]="true" styleClass="flex-shrink-0" />
                    </div>

                    <!-- Lista resumida de indicadores vinculados -->
                    <div class="flex flex-column gap-1 mb-3">
                      <span class="eco-label mb-1">Indicadores Vinculados:</span>
                      <div class="flex flex-column gap-1 max-h-10rem overflow-y-auto pr-1">
                        @for (ind of pessoa.indicadores; track ind.id) {
                          <div class="p-2 border-round-lg bg-teal-50 border-1 border-teal-100 flex align-items-center justify-content-between text-xs">
                            <div class="flex align-items-center gap-2 min-w-0">
                              <span class="font-bold text-teal-900 flex-shrink-0">[{{ ind.sigla }}]</span>
                              <span class="text-800 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ ind.nome }}</span>
                            </div>
                            @if (!ind.ativo) {
                              <span class="text-micro text-red-600 font-bold ml-1 flex-shrink-0">(Inativo)</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="mt-2 pt-3 border-t-1 border-teal-100 flex justify-content-end">
                    <p-button 
                      label="Gerenciar" 
                      icon="pi pi-cog" 
                      severity="secondary" 
                      [outlined]="true" 
                      size="small" 
                      [rounded]="true" 
                      styleClass="w-full sm:w-auto"
                      (onClick)="openManageModal(pessoa)" />
                  </div>
                </article>
              </div>
            } @empty {
              <div class="col-12 py-6 text-center flex flex-column align-items-center gap-3">
                <span class="material-symbols-outlined text-5xl text-400">group_off</span>
                <div>
                  <p class="font-bold text-lg my-0">
                    {{ searchResponsavelQuery() ? 'Nenhum responsável encontrado para a busca' : 'Nenhum responsável vinculado' }}
                  </p>
                  <p class="eco-meta my-0 mt-1">
                    {{ searchResponsavelQuery() ? 'Tente buscar com outro termo ou e-mail.' : 'Clique em "Novo Responsável" para cadastrar o primeiro vínculo.' }}
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </main>

  <!-- Modal de Gerenciar Responsável -->
  <p-dialog 
    header="Gerenciar Responsável" 
    [(visible)]="showManageModal" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '580px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeManageModal()">
    
    <div class="flex flex-column gap-4 pt-2">
      @if (manageError()) {
        <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-semibold flex align-items-center gap-2">
          <span class="material-symbols-outlined text-sm text-red-600">error</span>
          <span>{{ manageError() }}</span>
        </div>
      }

      <!-- Seção 1: Editar E-mail -->
      <div class="flex flex-column gap-2 p-3 bg-teal-50 border-round-xl border-1 border-teal-100">
        <label class="eco-label">E-mail Institucional</label>
        <div class="flex gap-2">
          <input 
            type="email" 
            [ngModel]="manageEmail()" 
            (ngModelChange)="manageEmail.set($event)"
            class="eco-input flex-1" 
            placeholder="usuario@tjpb.jus.br">
          <p-button 
            label="Salvar E-mail" 
            icon="pi pi-check" 
            severity="primary" 
            size="small" 
            [disabled]="!manageEmail() || manageEmail().trim().toLowerCase() === selectedPessoaToManage()?.email || submittingManage()"
            [loading]="submittingManage()"
            (onClick)="saveManageEmail()" />
        </div>
        <p class="text-micro text-600 my-0">A alteração atualizará todos os vínculos operacionais deste responsável.</p>
      </div>

      <!-- Seção 2: Indicadores Vinculados -->
      <div class="flex flex-column gap-2">
        <div class="flex justify-content-between align-items-center">
          <span class="eco-label">Indicadores Vinculados ({{ selectedPessoaToManage()?.indicadores?.length || 0 }})</span>
        </div>

        <div class="flex flex-column gap-2 max-h-14rem overflow-y-auto pr-1">
          @for (ind of selectedPessoaToManage()?.indicadores; track ind.id) {
            <div class="bg-white p-2 border-round-xl flex align-items-center justify-content-between border-1 border-teal-100 shadow-xs">
              <div class="flex align-items-center gap-2 min-w-0 flex-1 mr-2">
                <span class="font-bold text-xs text-teal-800 flex-shrink-0">[{{ ind.sigla }}]</span>
                <span class="text-xs text-800 font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ ind.nome }}</span>
              </div>
              <p-button 
                icon="pi pi-times" 
                severity="danger" 
                [text]="true" 
                [rounded]="true" 
                size="small" 
                pTooltip="Desvincular indicador"
                [disabled]="submittingManage()"
                (onClick)="removeIndicadorFromManagePessoa(ind.id)" />
            </div>
          }
        </div>
      </div>

      <!-- Seção 3: Adicionar Novos Indicadores -->
      <div class="flex flex-column gap-2 pt-2 border-t-1 border-teal-100">
        <label class="eco-label">Adicionar Novos Indicadores</label>
        
        @if (availableIndicatorsToAdd().length > 0) {
          <div class="flex flex-column gap-2">
            <p-multiselect 
              [options]="availableIndicatorsToAdd()" 
              [(ngModel)]="manageSelectedIndicadorIdsToAdd"
              optionLabel="label" 
              optionValue="value"
              [filter]="true" 
              filterPlaceholder="Filtrar por nome ou sigla..."
              placeholder="Selecione um ou mais indicadores..." 
              [style]="{ width: '100%' }"
              appendTo="body"
              scrollHeight="220px"
              display="chip" />
            
            <div class="flex justify-content-end">
              <p-button 
                label="Adicionar Indicador(es)" 
                icon="pi pi-plus" 
                severity="secondary" 
                size="small" 
                [disabled]="manageSelectedIndicadorIdsToAdd().length === 0 || submittingManage()"
                [loading]="submittingManage()"
                (onClick)="addIndicadoresToManagePessoa()" />
            </div>
          </div>
        } @else {
          <p class="eco-meta font-italic my-0">Este responsável já está vinculado a todos os indicadores ativos disponíveis.</p>
        }
      </div>

      <div class="flex justify-content-end pt-2 border-t-1 border-teal-100">
        <p-button label="Fechar" severity="secondary" [outlined]="true" size="small" (onClick)="closeManageModal()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Novo Responsável -->
  <p-dialog 
    header="Novo Responsável" 
    [(visible)]="showNewResponsavelModal" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '540px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeNewResponsavelModal()">
    
    <div class="flex flex-column gap-3 pt-2">
      <p class="eco-meta line-height-3 my-0">
        Informe o e-mail institucional e selecione pelo menos um indicador para criar o vínculo inicial.
      </p>

      @if (newResponsavelError()) {
        <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-semibold flex align-items-center gap-2">
          <span class="material-symbols-outlined text-sm text-red-600">error</span>
          <span>{{ newResponsavelError() }}</span>
        </div>
      }

      <div class="flex flex-column gap-1">
        <label class="eco-label">E-mail Institucional *</label>
        <input 
          type="email" 
          [ngModel]="newResponsavelEmail()" 
          (ngModelChange)="newResponsavelEmail.set($event)"
          placeholder="exemplo@tjpb.jus.br" 
          class="eco-input">
      </div>

      <div class="flex flex-column gap-1">
        <label class="eco-label">Indicadores a Vincular *</label>
        <p-multiselect 
          [options]="indicatorOptions()" 
          [(ngModel)]="newResponsavelIndicadorIds"
          optionLabel="label" 
          optionValue="value"
          [filter]="true" 
          filterPlaceholder="Filtrar por nome ou sigla..."
          placeholder="Selecione um ou mais indicadores..." 
          [style]="{ width: '100%' }"
          appendTo="body"
          scrollHeight="220px"
          display="chip" />
      </div>

      <div class="flex justify-content-end gap-2 pt-3 border-t-1 border-teal-100">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeNewResponsavelModal()" />
        <p-button 
          label="Adicionar Responsável" 
          icon="pi pi-check" 
          severity="primary" 
          size="small" 
          [disabled]="!newResponsavelEmail() || newResponsavelIndicadorIds().length === 0 || submittingNewResponsavel()" 
          [loading]="submittingNewResponsavel()" 
          (onClick)="saveNewResponsavel()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Exclusão Definitiva (Apenas Arquivados) -->
  <p-dialog 
    header="Excluir indicador definitivamente?" 
    [visible]="showDeleteConfirmModal()" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '480px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeDeleteConfirmation()">
    
    <div class="flex flex-column gap-3 pt-2">
      <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl flex align-items-center gap-3 text-red-900">
        <span class="material-symbols-outlined text-3xl text-red-600 flex-shrink-0">warning</span>
        <div>
          <p class="font-bold text-sm my-0">Esta ação é permanente e irreversível!</p>
          <p class="eco-meta text-red-800 my-0 mt-1">Todos os registros de coleta e vínculos vinculados a esta métrica serão apagados permanentemente.</p>
        </div>
      </div>

      <p class="eco-meta line-height-3 my-0">
        Você está prestes a excluir permanentemente:
      </p>

      <div class="eco-card-low flex align-items-center gap-3">
        <p-tag [value]="indicatorToDelete()?.sigla || ''" severity="danger" [rounded]="true" />
        <span class="text-sm font-bold text-800">{{ indicatorToDelete()?.nome }}</span>
      </div>

      @if (deleteError()) {
        <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-semibold flex align-items-center gap-2">
          <span class="material-symbols-outlined text-sm text-red-600">error</span>
          <span>{{ deleteError() }}</span>
        </div>
      }

      <div class="flex justify-content-end gap-2 pt-2 border-t-1 border-teal-100">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeDeleteConfirmation()" />
        <p-button 
          label="Excluir Definitivamente" 
          icon="pi pi-trash" 
          severity="danger" 
          size="small" 
          [loading]="deletingIndicator()" 
          (onClick)="confirmDeleteIndicator()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Arquivamento de Indicador -->
  <p-dialog header="Arquivar indicador?" [visible]="!!indicatorToArchive()" [modal]="true"
    [style]="{ width: '90vw', maxWidth: '460px' }" [draggable]="false" [resizable]="false"
    (onHide)="closeArchiveConfirmation()">
    <div class="flex flex-column gap-3 pt-2">
      <p class="eco-meta line-height-3 my-0">O indicador deixará de receber novas coletas automáticas. Os dados e coletas já existentes serão preservados.</p>
      <div class="flex justify-content-end gap-2 pt-2">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeArchiveConfirmation()" />
        <p-button label="Arquivar" icon="pi pi-inbox" severity="primary" size="small" (onClick)="confirmArchiveIndicator()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Lançamento de Coleta Individual -->
  <p-dialog 
    header="Lançar Coleta Pendente" 
    [(visible)]="showCreateCollectionModal" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '480px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeCreateCollectionModal()">
    
    <div class="flex flex-column gap-3 pt-2">
      <p class="eco-meta line-height-3 my-0">
        Gerar tarefa de coleta com status <b class="text-teal-800 font-bold">Pendente</b> para o indicador:
      </p>

      <div class="eco-card-low flex align-items-center gap-3">
        <p-tag [value]="indicatorForCollection()?.sigla || ''" severity="info" [rounded]="true" />
        <span class="text-sm font-bold text-800 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ indicatorForCollection()?.nome }}</span>
      </div>

      @if (collectionError()) {
        <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-semibold flex align-items-center gap-2">
          <span class="material-symbols-outlined text-sm text-red-600">error</span>
          <span>{{ collectionError() }}</span>
        </div>
      }

      <div class="flex flex-column gap-1">
        <label class="eco-label">{{ indicatorForCollection()?.periodicidade === 'ANUAL' ? 'Ano de Referência *' : 'Mês / Ano de Referência *' }}</label>
        <input 
          [type]="indicatorForCollection()?.periodicidade === 'ANUAL' ? 'number' : 'month'"
          [min]="indicatorForCollection()?.periodicidade === 'ANUAL' ? 1900 : null"
          [max]="indicatorForCollection()?.periodicidade === 'ANUAL' ? 2100 : null"
          [ngModel]="collectionForm().referencia" 
          (ngModelChange)="collectionForm.set({ referencia: $event })"
          class="eco-input">
      </div>

      <div class="flex justify-content-end gap-2 pt-2">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeCreateCollectionModal()" />
        <p-button 
          label="Criar Coleta" 
          icon="pi pi-check" 
          severity="primary" 
          size="small" 
          [disabled]="!collectionForm().referencia || submittingCollection()" 
          [loading]="submittingCollection()" 
          (onClick)="confirmCreateCollection()" />
      </div>
    </div>
  </p-dialog>

  <!-- Modal de Importação PrimeNG Dialog -->
  <p-dialog 
    header="Importar Base de Dados (.xlsx)" 
    [(visible)]="showImportModal" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '580px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="closeImportModal()">
    
    <div class="flex flex-column gap-3 pt-2">
      @if (!importSummary()) {
        <p class="eco-meta line-height-3 my-0">
          Selecione a planilha Excel (<code class="bg-teal-50 px-1 py-0.5 border-round text-teal-800">.xlsx</code>). O sistema importará automaticamente as abas compatíveis (<code class="eco-meta">indicadores</code>, <code class="eco-meta">coletas_mensais</code>, etc.).
        </p>

        <div class="border-2 border-dashed border-teal-200 border-round-2xl p-5 text-center hover:bg-teal-50 transition-colors">
          <input type="file" (change)="onFileSelected($event)" accept=".xlsx, .xls" id="xlsxFileInput" class="hidden">
          <label for="xlsxFileInput" class="cursor-pointer flex flex-column align-items-center gap-2">
            <span class="material-symbols-outlined text-4xl text-teal-700">upload_file</span>
            <span class="text-sm font-bold text-800">
              {{ selectedFile() ? selectedFile()!.name : 'Clique para selecionar o arquivo .xlsx' }}
            </span>
            <span class="eco-meta">Suporta estrutura atual e legada</span>
          </label>
        </div>

        <!-- Seleção de Modo de Importação -->
        <div class="flex flex-column gap-2 mt-1">
          <label class="eco-label">Modo de Processamento (Dupla Paridade):</label>
          <div class="grid text-xs">
            <div class="col-12 md:col-4 p-1">
              <button 
                type="button" 
                (click)="importMode.set('AUTO')" 
                [class.border-teal-600]="importMode() === 'AUTO'" 
                [class.bg-teal-50]="importMode() === 'AUTO'" 
                [class.border-teal-200]="importMode() !== 'AUTO'"
                class="w-full text-left p-2 border-1 border-round-xl cursor-pointer transition-all flex flex-column gap-1 hover:border-teal-400">
                <div class="flex align-items-center gap-1 font-bold text-teal-900">
                  <span class="material-symbols-outlined text-sm text-teal-700">auto_awesome</span>
                  <span>Automático</span>
                </div>
                <span class="text-600 text-xs font-normal line-height-2">Detecta estrutura automaticamente</span>
              </button>
            </div>

            <div class="col-12 md:col-4 p-1">
              <button 
                type="button" 
                (click)="importMode.set('EXPORT')" 
                [class.border-teal-600]="importMode() === 'EXPORT'" 
                [class.bg-teal-50]="importMode() === 'EXPORT'" 
                [class.border-teal-200]="importMode() !== 'EXPORT'"
                class="w-full text-left p-2 border-1 border-round-xl cursor-pointer transition-all flex flex-column gap-1 hover:border-teal-400">
                <div class="flex align-items-center gap-1 font-bold text-teal-900">
                  <span class="material-symbols-outlined text-sm text-teal-700">download_for_offline</span>
                  <span>Modo Exportação</span>
                </div>
                <span class="text-600 text-xs font-normal line-height-2">Paridade com exportação nativa</span>
              </button>
            </div>

            <div class="col-12 md:col-4 p-1">
              <button 
                type="button" 
                (click)="importMode.set('LEGACY')" 
                [class.border-teal-600]="importMode() === 'LEGACY'" 
                [class.bg-teal-50]="importMode() === 'LEGACY'" 
                [class.border-teal-200]="importMode() !== 'LEGACY'"
                class="w-full text-left p-2 border-1 border-round-xl cursor-pointer transition-all flex flex-column gap-1 hover:border-teal-400">
                <div class="flex align-items-center gap-1 font-bold text-teal-900">
                  <span class="material-symbols-outlined text-sm text-teal-700">history</span>
                  <span>Modo Legado</span>
                </div>
                <span class="text-600 text-xs font-normal line-height-2">Base antiga (ecodados_database)</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Opção Destrutiva: Reset Completo -->
        <div class="mt-1 p-3 bg-red-50 border-1 border-red-200 border-round-xl flex align-items-center gap-2">
          <input 
            type="checkbox" 
            id="cleanImportCheckbox" 
            [checked]="cleanImport()" 
            (change)="cleanImport.set(!cleanImport())" 
            class="cursor-pointer">
          <label for="cleanImportCheckbox" class="cursor-pointer eco-meta font-bold text-red-900 flex align-items-center gap-1 select-none">
            <span class="material-symbols-outlined text-sm text-red-700">warning</span>
            <span>Reset completo (excluir TODOS os dados existentes antes de importar)</span>
          </label>
        </div>

        <div class="flex justify-content-end gap-2 pt-2">
          <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="closeImportModal()" />
          <p-button 
            label="Iniciar Importação" 
            icon="pi pi-check" 
            severity="primary" 
            size="small" 
            [disabled]="!selectedFile() || dataTransferService.importing()" 
            [loading]="dataTransferService.importing()" 
            (onClick)="submitImport()" />
        </div>
      } @else {
        <div class="flex flex-column gap-3">
          <div class="p-3 bg-green-50 border-1 border-green-200 border-round-2xl flex align-items-center gap-3 text-green-900">
            <span class="material-symbols-outlined text-2xl text-green-600">check_circle</span>
            <div>
              <p class="font-bold text-sm my-0">Importação realizada com sucesso!</p>
              <p class="eco-meta text-green-800 my-0 mt-1">Registros atualizados por tabela:</p>
            </div>
          </div>

          <div class="grid text-xs">
            @for (entry of importSummary() | keyvalue; track entry.key) {
              <div class="col-6 p-1">
                <div class="eco-card-low flex align-items-center justify-content-between">
                  <span class="font-medium text-600">{{ getTableLabel(entry.key) }}:</span>
                  <span class="font-bold text-teal-800">{{ entry.value }}</span>
                </div>
              </div>
            }
          </div>

          <div class="flex justify-content-end pt-2">
            <p-button label="Concluir" severity="primary" size="small" (onClick)="closeImportModal()" />
          </div>
        </div>
      }
    </div>
  </p-dialog>

  <!-- Menu Drawer Mobile -->
  <p-drawer 
    [(visible)]="showMobileMenu" 
    position="right" 
    [style]="{ width: '280px', maxWidth: '85vw' }"
    [modal]="true">
    <ng-template #header>
      <div class="flex align-items-center gap-2">
        <div class="eco-brand-badge" style="width: 38px; height: 38px; min-width: 38px; min-height: 38px;">
          <img src="assets/ecodados-symbol.svg" alt="EcoDados Logo" style="width: 24px; height: 24px;">
        </div>
        <div class="flex flex-column">
          <span class="font-bold text-sm text-800">EcoDados</span>
          <span class="eco-meta">Navegação</span>
        </div>
      </div>
    </ng-template>

    <div class="flex flex-column justify-content-between h-full pt-3 pb-2">
      <div class="flex flex-column gap-2">
        <a routerLink="/coletas" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
          <span class="material-symbols-outlined text-xl text-teal-700">task_alt</span>
          <span>Minhas Coletas</span>
        </a>

        @if (role() === 'ADMIN') {
          <a routerLink="/indicadores" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
            <span class="material-symbols-outlined text-xl text-teal-700">tune</span>
            <span>Painel Admin</span>
          </a>

          <a routerLink="/analytics" routerLinkActive="active" (click)="showMobileMenu.set(false)" class="eco-mobile-nav-link">
            <span class="material-symbols-outlined text-xl text-teal-700">analytics</span>
            <span>Gráficos</span>
          </a>
        }
      </div>

      <!-- Rodapé do menu mobile -->
      <div class="border-t-1 border-teal-100 pt-3 flex flex-column gap-2">
        <div class="px-2 py-1 flex flex-column">
          <span class="text-xs font-bold text-800">{{ authService.currentUser()?.name }}</span>
          <span class="eco-meta">{{ role() === 'ADMIN' ? 'Administrador' : 'Responsável' }}</span>
        </div>
        <button (click)="logout()" class="eco-mobile-nav-link text-red-700 hover:bg-red-50 cursor-pointer border-none bg-transparent w-full text-left">
          <span class="material-symbols-outlined text-xl text-red-600">logout</span>
          <span>Sair do sistema</span>
        </button>
      </div>
    </div>
  </p-drawer>
</div>
